import http from "../http-common";

const getAllScholarships = (lang) => {
  if(lang === 'en') {
    return http.get("/sok?lang=en");
  } else {
    return http.get("/sok");
  }
};

const getScholarship = (id, lang) => {
  if(lang === 'en') {
    return http.get(`/stipendium/${id}?lang=en`);
  } else {
    return http.get(`/stipendium/${id}`);
  }
};

const getNations = () => {
  return http.get(`/filter/nationer`);
};

const getFaculties = (lang) => {
  if(lang === 'en') {
    return http.get("/filter/fakulteter?lang=en");
  } else {
    return http.get("/filter/fakulteter");
  }
};

const getKinship  = (lang) => {
  if(lang === 'en') {
    return http.get("/filter/slaktingar?lang=en");
  } else {
    return http.get("/filter/slaktingar");
  }
};

const getCounties = (lang) => {
  if(lang === 'en') {
    return http.get("/filter/lan?lang=en");
  } else {
    return http.get("/filter/lan");
  }
};

const getSpecificQualifications = (lang) => {
  if(lang === 'en') {
    return http.get("/filter/behorigheter?lang=en");
  } else {
    return http.get("/filter/behorigheter");
  }
};

const getSystemMessages = (lang) => {
  if(lang === 'en') {
    return http.get("/system-messages?lang=en");
  } else {
    return http.get("/system-messages");
  }
}


const getUser = () => {
  return http.get("/user");
}

const getScholarshipsInApplication = () => {
  return http.get("/ledigaStipendier/stipendieriansokan");
}

const saveApplication = (stipendier, kungorelseomgang, termin) => {
  return http.get(`/ledigaStipendier/startaansok?stipendier=${stipendier}&kungorelseomgang=${kungorelseomgang}&termin=${termin}`);
}

const deleteScholarshipInApplication = (kungorelseomgang, termin, scholarshipId) => {
  return http.delete(`/ledigaStipendier/ansokan/tabort/${kungorelseomgang}/${termin}/${scholarshipId}`);
}

const getActiveApplicationsForUser = () => {
  return http.get("/ledigaStipendier/ansokningar");
}

const ScholarshipService = {
  getAllScholarships,
  getScholarship,
  getNations,
  getFaculties,
  getKinship,
  getCounties,
  getSpecificQualifications,
  getUser,
  getScholarshipsInApplication,
  saveApplication,
  deleteScholarshipInApplication,
  getActiveApplicationsForUser,
  getSystemMessages
};
export default ScholarshipService;